<div
  class="wrapper"
  *ngIf="allocationViewAvailableDocksFacade.loaded$ | async"
  [style.height]="!!(allocationViewAvailableDocksFacade.items$ | async)?.compartments?.length ? '90vh' : 'unset'"
>
  <h1 class="title">
    {{ data?.label }}
    {{ 'monitoring.selection' | translate }}
  </h1>

  <div
    class="list"
    *ngIf="!!(allocationViewAvailableDocksFacade.items$ | async)?.compartments?.length; else notAvailable"
  >
    <div *ngFor="let formGroup of formArray?.controls; let i = index" class="list__item">
      <mat-checkbox
        [formControl]="formGroup?.get('compartment')?.get('isSelected')"
        (change)="$event ? compartmentToggle(i) : null"
        [checked]="formGroup.get('compartment').get('isSelected').value"
        class="list__item-checkbox"
        [ngClass]="{
          selected: formGroup.get('compartment').get('isSelected')
        }"
      >
        <span class="list__item-text" cropText>
          {{ 'monitoring.uli.tile.compartment' | translate }}:
          {{ formGroup.get('compartment').value?.name }}
        </span>
      </mat-checkbox>
      <div class="list__item-options">
        <div *ngFor="let dock of formGroup.get('docks')['controls']">
          <mat-checkbox
            [formControl]="dock.get('isSelected')"
            (change)="$event ? selectDock(dock.get('isSelected').value, i) : null"
          >
            <span class="list__item-text" cropText>
              {{ dock.get('name').value }}
            </span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="action-buttons">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      *ngIf="!!(allocationViewAvailableDocksFacade.items$ | async)?.compartments?.length"
      [action]="buttonAction.Apply"
      (buttonClick)="apply()"
    ></ui-action-button>
  </div>
</div>

<ng-template #notAvailable>
  <div class="not-available">
    {{ 'monitoring.allocationView.compartmentDockDialog.noItems' | translate }}
  </div>
</ng-template>
